import { UpdateIconButton, pn, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@compass/core";

import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  SuppliesDetailListDto,
  SuppliesDetailListResource,
} from "generated/openApi";
import { Draggable } from "react-beautiful-dnd";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { suppliesDetailPageRoute } from "../SuppliesDetailPage/SuppliesDetailPage";

export const SuppliesDetailTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  suppliesDetails: SuppliesDetailListDto[];
  setSuppliesDetails: (suppliesDetails: SuppliesDetailListDto[]) => void;
  resource: SuppliesDetailListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SuppliesDetailListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SuppliesDetailListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.suppliesDetails.map((suppliesDetailItem) => (
            <TableRow
              key={suppliesDetailItem.id}
              onClick={() =>
                navigate(
                  suppliesDetailPageRoute.getPath({
                    id: suppliesDetailItem.id,
                    crudMode: "view",
                  })
                )
              }
            >
              <TableCell type="id">{suppliesDetailItem.id}</TableCell>
              <TableCell>{suppliesDetailItem.name}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    onClick={() =>
                      navigate(
                        suppliesDetailPageRoute.getPath({
                          id: suppliesDetailItem.id,
                          crudMode: "edit",
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
